import { IVo } from '@wizeoo/akm-compute-lib';
import { BasicEntity } from '@wizeoo/akm-message-lib';

export class BasicEntityVO<T extends BasicEntity> implements IVo {
  constructor(pSource: T) {
    this._source = pSource;
  }

  /** L'objet source provenant du back */
  private _source: T;
  public get source(): T {
    return this._source;
  }
  public set source(value: T) {
    this._source = value;
  }

  // Id technique
  public get id(): number {
    return this._source.id;
  }
  public set id(value: number) {
    this._source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this._source.uid;
  }
  public set uid(value: string) {
    this._source.uid = value;
  }

  // code domaine (root), technique
  public get domain(): string {
    return this._source.domain;
  }
  public set domain(value: string) {
    this._source.domain = value;
  }

  public get businessUnitCode(): string {
    // code de la BU
    return this._source.businessUnitCode;
  }
  public set businessUnitCode(value: string) {
    this._source.businessUnitCode = value;
  }

  set updateTime(value: number) {
    this._source.updateTime = value;
  }
  // Date de dernière modification
  get updateTime(): number {
    return this._source.updateTime;
  }
}
